import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faPlus} from "@fortawesome/free-solid-svg-icons";
import {useEffect, useState} from "react";
import {message} from "antd";
import {SkillForm} from "@/pages/resume/components/forms/SkillForm";

export const SkillIndex = ({onChange}) => {
    const [skillForm, setSkillForm] = useState([]);

    useEffect(() => {
        onChange(skillForm);
    }, [skillForm]);

    const addForm = () => {
        if( skillForm.length < 5 ) {
            setSkillForm([...skillForm, {id: Date.now()}]);
        }else {
            message.error("Chỉ được thêm tối đa 5 kỹ năng");
        }
    }

    const removeForm = (id) => {
        setSkillForm(skillForm.filter(skill => skill.id !== id));
    }

    return (
        <div className={"border rounded-lg p-4 shadow-md w-full"}>
            <div className={"space-y-8 flex justify-between items-center"}>
                <h2 className={"text-lg font-semibold"}>Kỹ năng</h2>
                <button className={"text-gray-700"} onClick={addForm}>
                    <FontAwesomeIcon icon={faPlus} className={"me-2"}/> Thêm kinh nghiệp
                </button>
            </div>
            <div className={"grid grid-cols-1 gap-4 mt-4"}>
                {skillForm.map((skf) => (
                    <SkillForm key={skf.id} id={skf.id} onRemove={removeForm}/>
                ))}
            </div>
        </div>
    )
}